import React from "react";

const C1BenefitsHead = () => {
  return (
    <div className="lvlBenefitsHead">
      <h2>
        Benefits of C1 Level German Course at <span>Prizma Academy</span>
      </h2>
      <p>
        Achieve higher proficiency in German with our C1 Level German Course,
        subdivided into C1.1 and C1.2. Here’s what you can expect:
      </p>
    </div>
  );
};

export default C1BenefitsHead;
